import { Matrix } from '@babylonjs/core/Maths';
import { MeshNode } from '@kb3d/models/classes/meshes/mesh-node';
import { KbVector } from '@kb3d/models/classes/primitives/kb-vector';
import { computeLocalTransform } from '../helpers/math-helper';

export function bakeMeshTransform(node: MeshNode) {
    const newTransform = computeLocalTransform(node);

    if (node.preTransform) {
        if (node.preTransform.length !== 16) {
            throw Error('invalid pretransform array ');
        }
        const preTransform = Matrix.FromArray(node.preTransform);
        preTransform.multiplyToRef(newTransform, newTransform);
    }
    node.preTransform = Array.from(newTransform.toArray());

    node.pivot = KbVector.Zero();
    node.position = KbVector.Zero();
    node.scaling = 1;
    node.rotationAngle = 0;
    node.rotationAxis = new KbVector(0, 1, 0);
    node.eulerRotation = KbVector.Zero();

    return node;
}
